import keyMirror from 'keymirror';

export const addWysiwygImageModalActionTypes = keyMirror({
	HANDLE_ADD_WYSIWYG_IMAGE_MODAL: null,
	UPLOAD_WYSIWYG_IMAGE_REQUEST: null,
	UPLOAD_WYSIWYG_IMAGE_SUCCESS: null,
	UPLOAD_WYSIWYG_IMAGE_ERROR: null,
});
